import { Avatar, Box, Button, Typography } from '@mui/material';
import { FaWhatsapp } from 'react-icons/fa6';
import background from '../../assets/hero_bg.jpg';

function initial(name) {
    const letter = String(name || '').trim().charAt(0);
    return letter ? letter.toUpperCase() : '';
}

export default function PartnerCatalogHero({ name, image, whatsappHref }) {
    return (
        <Box sx={styles.hero}>
            <Box sx={styles.photo} aria-hidden />
            <Box sx={styles.veil} aria-hidden />
            <Box sx={styles.body}>
                <Avatar src={image || undefined} alt={name ? `Logo ${name}` : ''} sx={styles.avatar}>
                    {initial(name)}
                </Avatar>
                <Typography component="h1" variant="h1" sx={styles.title}>
                    {name || 'Joias'}
                </Typography>
                <Typography sx={styles.lede}>
                    Fale com a loja no WhatsApp para pedir ou tirar dúvida.
                </Typography>
                {whatsappHref && (
                    <Button
                        variant="contained"
                        color="secondary"
                        startIcon={<FaWhatsapp size={16} />}
                        href={whatsappHref}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Falar no WhatsApp
                    </Button>
                )}
            </Box>
        </Box>
    );
}

const styles = {
    hero: {
        position: 'relative',
        color: 'common.white',
        borderBottom: '2px solid',
        borderColor: 'secondary.main',
        overflow: 'hidden',
    },
    photo: {
        position: 'absolute',
        inset: 0,
        backgroundImage: `url(${background})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    },
    veil: {
        position: 'absolute',
        inset: 0,
        bgcolor: 'primary.main',
        opacity: 0.72,
    },
    body: {
        position: 'relative',
        px: { xs: 2, md: 4 },
        pt: { xs: 5, md: 6 },
        pb: { xs: 4, md: 5 },
        maxWidth: 640,
        mx: 'auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
    },
    avatar: {
        width: 72,
        height: 72,
        mb: 2.5,
        bgcolor: 'background.paper',
        color: 'primary.main',
        fontFamily: 'DM Serif Display',
        fontSize: '1.75rem',
        border: '1px solid',
        borderColor: 'secondary.main',
    },
    title: {
        color: 'common.white',
        textAlign: 'center',
        fontSize: { xs: '2rem', md: '3rem' },
    },
    lede: {
        mt: 1.5,
        mb: 3,
        color: 'common.white',
        textAlign: 'center',
        maxWidth: 440,
        opacity: 0.92,
    },
};
